import React, { Component, useState, useEffect } from "react";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import "../common/index.scss";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
// import custom Components
import ProductListing from "./common/product-listing";
import Breadcrumb from "../common/breadcrumb";
import FilterBar from "./common/filter-bar";
import { HistoryTwoTone } from "@material-ui/icons";

const CollectionNoSideBar = (props) => {
  const [layoutColumns, setLayoutColumns] = useState(3);
  const [limit, setLimit] = useState(6);
  const { user } = useSelector((state) => state.auth);
  const totalDocs = useSelector((state) => state.products.total);
  const history = useHistory();
  //   state = {
  //     layoutColumns: 3,
  //   }
  useEffect(() => {
    if (user && user.role === "member") {
      history.push(`${process.env.PUBLIC_URL}/`);
    } else if (user && user.role === "customer") {
      history.push(`${process.env.PUBLIC_URL}/`);
    } else if (!user) {
      history.push(`${process.env.PUBLIC_URL}/`);
    }
  }, [user]);
  const LayoutViewClicked = (columns, limit) => {
    // this.setState({
    //   layoutColumns: colums,
    // })
    setLayoutColumns(columns);
    setLimit(limit);
  };

  //   componentWillReceiveProps(nextProps) {
  //     if (this.props.user != nextProps.user) {
  //       this.props.history.push(`${process.env.PUBLIC_URL}/`)
  //     }
  //   }

  //   render() {
  // console.log(user)
  // if(user.role==='member'){
  // 	history.replace(`${process.env.PUBLIC_URL}/`)
  // }
  return (
    <div>
      <Breadcrumb title={"Collection"} />

      {/*Section Start*/}
      <section className="section-b-space">
        <div className="collection-wrapper collection-shop">
          <div className="container">
            <div className="row">
              <div className="collection-content col">
                <div className="page-main-content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="collection-product-wrapper">
                          <div className="product-top-filter">
                            <div className="container-fluid p-0">
                              <div className="row">
                                <div className="col-12">
                                <FilterBar
                                    totalDocs={totalDocs}
                                    onLayoutViewClicked={(colmuns, limit) =>
                                      LayoutViewClicked(colmuns, limit)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="product-wrapper-grid">
                            <div className="container-fluid">
                              <div className="row">
                              <ProductListing colSize={layoutColumns} limit={limit} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*Section End*/}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default withRouter(connect(mapStateToProps)(CollectionNoSideBar));
